module.exports = require('react-router-dom');
module.exports.routerRedux = require('react-router-redux');



//////////////////
// WEBPACK FOOTER
// /Users/niko/Work/sketch/antd-pro/ant-design-pro-site/scaffold/node_modules/_dva@2.1.0@dva/router.js
// module id = 999
// module chunks = 0